import React, { useState, useEffect, useContext, useMemo, useRef } from 'react';
import ReactStars from 'react-rating-stars-component';
import { debounce, isEmpty } from 'lodash';
import APIService from '../../shared/services/api';
import Notify from '../../shared/notify';
import TextInput from '@shared/component/TextInput';
import List from '@shared/component/List';
import { AuthContext } from '@shared/context/AuthContext';
import { useParams } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import moment from 'moment';
import Modal from 'react-bootstrap/Modal';
import CustomDateTimePicker from '@shared/component/DatePicker';
import CheckValidator from '@shared/checkValidator';
import Lists from '@shared/component/Lists';
import { DateFormatPicker, TextTruncate } from '@utils/static/commonUtils';
import CommonRatingModal from './ratingModel';
import CommonModal from './viewModel';
import { actionsPermissionValidator, ActionValues } from '@utils/static/commonUtils';

export function FinalisedBids() {
    const [formData, setFormData] = useState<any>({
        status: null,
        actualdeliverydate: null,
        ontime: null,
        // remark: null,
        dispatchedDeliveryDate: null,
        deliveryOntime: null,
        DeliveryDate: null,
        vehicleArrivedStatus: null,
        isArrived: null,
    });
    const [errors, setError] = useState<any>({
        status: {
            required: true,
            error: true,
            message: 'Please select',
        },
        actualdeliverydate: {
            required: true,
            error: true,
            message: 'Please select date',
            min: new Date().toISOString().slice(0, 16),
        },
        ontime: {
            required: true,
            error: true,
            message: 'Please select',
        },
        // remark: {
        //     required: true,
        //     error: true,
        //     pattern: /^[A-Za-z0-9\s]*$/,
        //     message: 'Please enter remark',
        //     maxLength: 50,
        //     disabled: false,
        // },
    });
    const listRef: any = useRef(null);
    const { setLoader } = useContext(AuthContext);
    const [FinalisedBids, setFinalisedBids] = useState([]);
    const [showRatingModal, setShowRatingModal] = useState(false);
    const [demandModel, setDemandModel] = useState(false);
    const [id, setId] = useState(null);
    const [bidData, setBidData] = useState('');
    const [viewdata, setViewData] = useState([]);
    const [recordCount, setRecordCount] = useState(0);
    const [showHideModel, setShowHideModel] = useState(false);
    const [viewModel, setViewModel] = useState(false);
    const [pickupdate, setPickupDate] = useState(Date.now());
    const [demandDetail, setDemandDetail] = useState([]);
    const [isSubmit, setIsSubmit] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const params: any = useParams();
    const [edit, setedit] = useState(false);
    const [columns, setColumns] = useState({
        id: 'ID',
        'app_user.name': 'Vendor Name',
        'app_user.phone': 'Phone No.',
        'demand.category.name': 'Category Name',
        'demand.item.name': 'Item Name',
        deliveryStatus: 'Delivery Status',
        actualDeliveryDate: 'Arrival Date & Time',
        remark: 'Remarks',
        action: 'Action',
    });
    const handelModel = (flag: boolean) => {
        try {
            setShowHideModel(flag);
        } catch (error) { }
    };
    const handelViewModel = (flag: boolean) => {
        try {
            setViewModel(flag);
        } catch (error) { }
    };
    const handleShowRatingModal = () => {
        setShowRatingModal(true);
    };

    function formatDate(dateString) {
        return moment(dateString).format('DD MMM YYYY | hh.mm A');
    }

    const handleShowDemandModal = id => {
        const data: any = FinalisedBids.filter((item: any) => item.id == id);

        setViewData(data[0]);
        setDemandModel(true);
    };

    const handleHideRatingModal = () => {
        setShowRatingModal(false);
    };
    const handleRatingSubmit = async ({ rating, remarks }) => {
        // Handle the submitted rating and remarks
        try {
            if (rating == 0) {
                Notify('error', 'Please select rating');
                return;
            }
            const data = {
                rating,
                remark: remarks,
                appUserId: viewdata?.appUserId,
                bidId: viewdata?.id,
            };
            setLoader(true);
            const updateddata = await APIService.post('rating/', data, true, true);
            setLoader(false);
            if (updateddata.status === 200) {
                handleHideRatingModal();
                getFinalisedBids();
            }
        } catch (error) {
            setLoader(false);
        }
    };
    const searchItem = async (search: any, page: any) => {
        try {
            // setLoader(true);
            if (!page) {
                page = 1;
                listRef.current.resetPagination();
            }
            const data = await APIService.getAll(
                `bid/search?page=${page}&order=desc&type=transporter&sort=createdAt&search=${search}`,
                true,
                false,
            );
            setLoader(false);
            setFinalisedBids(data?.data?.data);
            setRecordCount(data.data.count);
        } catch (err) {
            setLoader(false);
        } finally {
            setLoader(false);
        }
    };
    const getValue = (e: any) => {
        try {
            const data = { ...formData, ...e };
            setFormData(data);
        } catch (error) { }
    };

    const getFinalisedBids = async (page: any = 1) => {
        try {
            setCurrentPage(page);
            setLoader(true);
            const data = await APIService.getAll(
                `bid/finalisedbids?page=${page}&sort=createdAt&type=transporter`,
                true,
                false,
            );
            setRecordCount(data?.data?.count);
            setFinalisedBids(data?.data?.data);
            setLoader(false);
        } catch (err) {
            setLoader(false);
        }
    };

    useEffect(() => {
        getFinalisedBids();
        handlereset();
    }, []);

    const updateStatus = async (item: any, status: any, id: any) => { };

    const getFinalisedBidsById = async (id: any, type) => {
        setId(id);

        const { 0: data }: any = FinalisedBids.filter((item: any) => item.id == id);
        if (data) {
            setPickupDate(data.demand?.pickUpDate);
            setDemandDetail(data.demand);
            if (data?.deliveryStatus == 'notArrived') {
                setFormData({
                    ['status']: data?.deliveryStatus,
                    // ['remark']: data?.remark,
                    ['ontime']: null,
                    ['actualdeliverydate']: null,
                });
            } else if (data) {
                const forDataObj = {
                    ['status']: data?.deliveryStatus,
                    // ['remark']: data?.remark,
                    ['ontime']: data?.isOnTime == true ? 'yes' : null,
                    ['actualdeliverydate']: data?.actualDeliveryDate || null,
                };
                if (data?.deliveryStatus == 'arrived') {
                    errors['dispatchedDeliveryDate'] = {
                        required: data?.dispatchedDeliveryDate ? false : true,
                        error: true,
                        message: 'Please select date',
                    };
                    // console.log('errors', errors)
                    setError(errors);
                    forDataObj['dispatchedDeliveryDate'] = data?.dispatchedDeliveryDate || null;
                } else if (data?.deliveryStatus == 'dispatched') {
                    delete errors['dispatchedDeliveryDate'];
                    errors['DeliveryDate'] = {
                        required: data?.DeliveryDate ? false : true,
                        error: true,
                        message: 'Please select date',
                    };
                    // console.log('errors', errors)
                    setError(errors);
                    forDataObj['DeliveryDate'] = data?.DeliveryDate || null;
                }

                setFormData(forDataObj);
            }

            setViewData(data);
            setBidData(data.deliveryStatus);
            if (type == 'rating') {
                handleShowRatingModal();
                return;
            }
            if (type == 'view') {
                handelViewModel(true);
                return;
            }

            setedit(true);

            handelModel(true);
        }
    };

    const minimumDispatchedDate = moment(viewdata?.actualDeliveryDate).format('YYYY-MM-DD');

    const minimumDeliveryDate = moment(viewdata?.dispatchedDeliveryDate).format('YYYY-MM-DD');

    const minimumArrivedDate = moment(demandDetail?.cutOffTime);
    const formattedDateCutof = minimumArrivedDate.format('YYYY-MM-DD');

    const maxArrivedDate = moment(demandDetail?.deliveryDate);
    const formatMaxArrived = maxArrivedDate.format('YYYY-MM-DD');

    const startDeliveryDate = moment(demandDetail?.pickUpDate);
    const formatedStartDeliveryDate = startDeliveryDate.format('YYYY-MM-DD');

    const currentDate = moment();
    const formattedCurrentDate = currentDate.format('YYYY-MM-DD');

    const handlereset = () => {
        setFormData({
            ['status']: null,
            ['remark']: null,
            ['ontime']: null,
            ['actualdeliverydate']: null,
        });
        setIsSubmit(false);
        setedit(false);
        handelModel(false);
    };

    const updateBidStatus = async () => {
        try {
            // return;
            if (formData.status == null) {
                Notify('error', 'Please select delivery status');
            } else {
                if (formData?.status == 'notArrived') {
                    delete formData?.ontime;
                    delete formData?.actualdeliverydate;
                }

                const isValid = await CheckValidator(errors, formData);
                setIsSubmit(!isValid);

                // return;
                if (isValid) {
                    let data = {};
                    if (formData.status == 'notArrived') {
                        data = {
                            isisArrived: formData.isArrived,
                            vehicleArrivedStatus: formData.status,
                            deliveryStatus: formData.status,
                            actualDeliveryDate: null,
                        };
                    } else if (bidData == 'arrived') {
                        if (new Date(viewdata?.actualDeliveryDate) > new Date(formData.dispatchedDeliveryDate)) {
                            Notify('error', 'Please choose after arrival date and time');
                            return;
                        }

                        data = {
                            dispatchDate: formData.dispatchedDeliveryDate,
                            deliveryStatus: 'dispatched',
                        };
                    } else if (formData.status == 'dispatched') {
                        if (new Date(viewdata?.dispatchedDeliveryDate) > new Date(formData.DeliveryDate)) {
                            Notify('error', 'Please choose  after dispatched date and time');
                            return;
                        }
                        data = {
                            deliveryStatus: 'delivered',
                            ontime: formData.ontime,
                            DeliveryDate: formData.DeliveryDate,
                        };
                    } else {
                        if (new Date(viewdata?.demand?.cutOffTime) > new Date(formData.actualdeliverydate)) {
                            Notify('error', 'Please choose after cut of time');
                            return;
                        }
                        data = {
                            deliveryStatus: formData.status,
                            isArrived: formData.isArrived,
                            vehicleArrivedStatus: formData.status,
                            actualDeliveryDate:
                                formData.actualdeliverydate != null || formData != ''
                                    ? formData.actualdeliverydate
                                    : null,
                        };
                    }

                    if (
                        formData.status == 'arrived' &&
                        formData.actualdeliverydate &&
                        !moment().isAfter(formData.actualdeliverydate)
                    ) {
                        Notify('error', 'Future time can`t be select');
                        return;
                    }

                    if (
                        formData.status == 'arrived' &&
                        formData.dispatchedDeliveryDate &&
                        !moment().isAfter(formData.dispatchedDeliveryDate)
                    ) {
                        Notify('error', 'Future time can`t be select');
                        return;
                    }

                    if (
                        formData.status == 'dispatched' &&
                        formData.DeliveryDate &&
                        !moment().isAfter(formData.DeliveryDate)
                    ) {
                        Notify('error', 'Future time can`t be select');
                        return;
                    }

                    // return

                    setLoader(true);

                    const updateddata = await APIService.update('bid', id, data, true, true);
                    setLoader(false);
                    if (updateddata.status === 200) {
                        Notify('success', 'Bid status updated successfully');

                        handelModel(false);
                        setedit(false);
                        handlereset();

                        getFinalisedBids(currentPage);
                    } else {
                        Notify('error', updateddata.data.message);
                    }
                }
            }
        } catch (err) {
            Notify('error', err?.response.data.message);
            setLoader(false);
        }
    };

    // format date and time
    const formattedDate = new Date(viewdata?.demand?.pickUpDate).toLocaleString();
    const formattedDateDelivery = new Date(viewdata?.expectedDeliveryDate).toLocaleString();

    const filterPassedTime = (time, type) => {
        try {
            // console.log('-----', demandDetail, type)

            const cdate = moment();
            const selectedDate = new Date(time);
            const cutOffDate = moment(demandDetail?.cutOffTime);
            const deliveryDate = moment(demandDetail?.deliveryDate);
            const pickUpDate = moment(demandDetail?.pickUpDate);

            if (
                cutOffDate.isBefore(cdate) &&
                deliveryDate.isBefore(cdate) &&
                pickUpDate.isBefore(cdate) &&
                type == 'arrive_date'
            ) {
                const currentDate = new Date(demandDetail?.cutOffTime);
                return currentDate.getTime() < selectedDate.getTime();
            }

            if (type == 'arrive_date') {
                const currentDate = new Date(demandDetail?.cutOffTime);
                // const currentDate = new Date(demandDetail?.cutOffTime);
                return currentDate.getTime() < selectedDate.getTime();
            } else if (type == 'dispatch_date') {
                const currentDate = new Date(viewdata?.actualDeliveryDate);
                return currentDate.getTime() < selectedDate.getTime();
            } else if (type == 'delivery_date') {
                const currentDate = new Date(viewdata?.dispatchedDeliveryDate);
                return currentDate.getTime() < selectedDate.getTime();
            }
        } catch (error) { }
    };

    const calculateMaxDate = type => {
        try {
            // console.log('type', type)
            if (type == 'arrive_date' || type == 'dispatch_date' || type == 'delivery_date') {
                const currentDate = moment();
                const deliveryDate = moment(demandDetail?.deliveryDate);
                if (deliveryDate.isAfter(currentDate)) {
                    return currentDate;
                } else {
                    return currentDate; //deliveryDate;
                }
            }
        } catch (error) {
            console.log('error', error);
        }
    };

    const arrivedModel = () => {
        return (
            <>
                <div className="field_box">
                    <h3>
                        <b>Vehicle Arrival Status</b>
                    </h3>
                    <div className="check_field_box mb-4">
                        <div className="form-check">
                            <input
                                className="form-check-input"
                                type="radio"
                                name="flexRadioDefault"
                                id="flexRadioDefault1"
                                value={'arrived'}
                                onChange={e => {
                                    setFormData({
                                        ...formData,
                                        ['status']: e.target.value,
                                    });
                                    getValue({ status: e.target.value });
                                    errors['actualdeliverydate'] = {
                                        required: true,
                                        error: true,
                                        message: 'Please select date',
                                        min: new Date().toISOString().slice(0, 16),
                                    };
                                    errors['status'] = {
                                        required: true,
                                        error: false,
                                        message: 'Please select',
                                    };
                                    setError(errors);
                                }}
                                checked={formData.status === 'arrived' ? true : false}
                                disabled={bidData === 'arrived' || bidData === 'notArrived'}
                            />
                            <label className="form-check-label" htmlFor="flexRadioDefault1">
                                Arrived
                            </label>
                        </div>
                        <div className="form-check">
                            <input
                                className="form-check-input"
                                type="radio"
                                name="flexRadioDefault"
                                id="flexRadioDefault2"
                                value={'notArrived'}
                                onChange={e => {
                                    setFormData({
                                        ...formData,
                                        ['status']: e.target.value,
                                    });
                                    getValue({ status: e.target.value });
                                    delete errors.actualdeliverydate;
                                    errors['status'] = {
                                        required: true,
                                        error: false,
                                        message: 'Please select',
                                    };
                                    setError(errors);
                                }}
                                checked={formData.status === 'notArrived' ? true : false}
                                disabled={bidData === 'arrived' || bidData === 'notArrived'}
                            />
                            <label className="form-check-label" htmlFor="flexRadioDefault2">
                                Not Arrived
                            </label>
                        </div>
                        {errors?.status?.required && errors?.status?.error && isSubmit && (
                            <div className="text-danger ft-12"> {errors?.status.message}</div>
                        )}
                    </div>
                    <div className="row">
                        {formData?.status === 'arrived' && (
                            <>
                                <div className="col-sm-12">
                                    <div className="form-floating">
                                        <CustomDateTimePicker
                                            data={{
                                                name: 'actualdeliverydate',
                                                placeholder: 'Select Arrived Date & Time',
                                                id: 'floatingInput',
                                                label: 'Select Arrived Date & Time',
                                                date: pickupdate,
                                            }}
                                            minDate={formattedDateCutof}
                                            maxDate={calculateMaxDate('arrive_date')}
                                            controlName="actualdeliverydate"
                                            isSubmit={isSubmit}
                                            value={
                                                formData?.actualdeliverydate != null ? formData?.actualdeliverydate : ''
                                            }
                                            setValue={(e: any) => getValue(e)}
                                            errorMsg={errors?.actualdeliverydate.message}
                                            inputProps={errors}
                                            filterPassedTime={time => filterPassedTime(time, 'arrive_date')}
                                        />
                                    </div>
                                </div>
                                <h3>
                                    <b>Was arrived on time?</b>
                                </h3>
                                <div className="check_field_box mb-4">
                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="flexRadioDefaulttime"
                                            id="flexRadioDefaulttime3"
                                            value={'yes'}
                                            onChange={e => {
                                                setFormData({
                                                    ...formData,
                                                    ['isArrived']: e.target.value,
                                                    ['ontime']: e.target.value,
                                                });
                                                // getValue({ isArrived: e.target.value });
                                                // errors['ontime'] = {
                                                //     required: true,
                                                //     error: false,
                                                //     message: 'Please select',
                                                // };
                                                setError(errors);
                                            }}
                                            checked={formData.isArrived === 'yes' ? true : false}
                                        />
                                        <label className="form-check-label" htmlFor="flexRadioDefaulttime3">
                                            Yes
                                        </label>
                                    </div>
                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="flexRadioDefaulttime"
                                            id="flexRadioDefaulttime4"
                                            value={'no'}
                                            onChange={e => {
                                                setFormData({
                                                    ...formData,
                                                    ['isArrived']: e.target.value,
                                                    ['ontime']: e.target.value,
                                                });
                                                // getValue({ isArrived: e.target.value });
                                                // errors['ontime'] = {
                                                //     required: true,
                                                //     error: false,
                                                //     message: 'Please select',
                                                // };
                                                setError(errors);
                                            }}
                                            checked={formData.isArrived === 'no' ? true : false}
                                        />
                                        <label className="form-check-label" htmlFor="flexRadioDefaulttime4">
                                            No
                                        </label>
                                    </div>
                                    {!formData.isArrived && isSubmit && (
                                        <div className="text-danger ft-12"> {errors?.ontime.message}</div>
                                    )}
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </>
        );
    };

    const dispatchedModel = () => {
        return (
            <>
                <div className="col-sm-12">
                    <div className="form-floating">
                        <CustomDateTimePicker
                            data={{
                                name: 'dispatchedDeliveryDate',
                                placeholder: 'Select Dispatch Date & Time',
                                id: 'floatingInput',
                                label: 'Select Dispatch Date & Time',
                                date: pickupdate,
                            }}
                            minDate={minimumDispatchedDate}
                            maxDate={calculateMaxDate('dispatch_date')}
                            controlName="dispatchedDeliveryDate"
                            isSubmit={isSubmit}
                            value={formData?.dispatchedDeliveryDate != null ? formData?.dispatchedDeliveryDate : null}
                            setValue={(e: any) => {
                                setFormData({
                                    ...formData,
                                    dispatchedDeliveryDate:
                                        e?.dispatchedDeliveryDate == '' ? null : e.dispatchedDeliveryDate,
                                    ['ontime']: 'no',
                                });
                            }}
                            errorMsg={'Please select date'}
                            inputProps={errors}
                            filterPassedTime={time => filterPassedTime(time, 'dispatch_date')}
                        />
                    </div>
                </div>
            </>
        );
    };

    const deliveryModel = () => {
        // console.log('viewData', viewdata, formData)
        return (
            <>
                <div className="col-sm-12">
                    <h3>
                        <b>Vehicle Delivery</b>
                    </h3>
                    <div className="form-floating d-flex">
                        {/* Commited Pickup Date & Time {formattedDateDelivery} */}
                        <div style={{ fontSize: 14 }}>Commited Delivery Date & Time</div>
                        <div
                            style={{
                                fontSize: 14,
                                marginLeft: 10,
                                fontWeight: 500,
                            }}
                        >
                            {formatDate(viewdata?.expectedDeliveryDate)}
                        </div>
                    </div>
                    <br></br>
                    <div className="form-floating">
                        <CustomDateTimePicker
                            data={{
                                name: 'DeliveryDate',
                                placeholder: 'Select Delivery Date & Time',
                                id: 'floatingInput',
                                label: 'Select Delivery Date & Time',
                                date: pickupdate,
                            }}
                            minDate={minimumDeliveryDate}
                            maxDate={calculateMaxDate('delivery_date')}
                            controlName="DeliveryDate"
                            isSubmit={isSubmit}
                            value={formData?.DeliveryDate != null ? formData?.DeliveryDate : ''}
                            setValue={(e: any) => getValue(e)}
                            // errorMsg={errors?.DeliveryDate.message}
                            inputProps={errors}
                            filterPassedTime={time => filterPassedTime(time, 'delivery_date')}
                        />
                    </div>
                    <br></br>
                    <h3>
                        <b>Was deliverd on time?</b>
                    </h3>
                    <div className="check_field_box mb-4">
                        <div className="form-check">
                            <input
                                className="form-check-input"
                                type="radio"
                                name="flexRadioDefaulttime"
                                id="flexRadioDefaulttime3"
                                value={'yes'}
                                onChange={e => {
                                    setFormData({
                                        ...formData,
                                        ['ontime']: e.target.value,
                                    });
                                    // getValue({ ontime: e.target.value });
                                    errors['ontime'] = {
                                        required: true,
                                        error: false,
                                        message: 'Please select',
                                    };
                                    setError(errors);
                                }}
                                checked={formData.ontime === 'yes' ? true : false}
                            />
                            <label className="form-check-label" htmlFor="flexRadioDefaulttime3">
                                Yes
                            </label>
                        </div>
                        <div className="form-check">
                            <input
                                className="form-check-input"
                                type="radio"
                                name="flexRadioDefaulttime"
                                id="flexRadioDefaulttime4"
                                value={'no'}
                                onChange={e => {
                                    setFormData({
                                        ...formData,
                                        ['ontime']: e.target.value,
                                    });
                                    // getValue({ ontime: e.target.value });
                                    errors['ontime'] = {
                                        required: true,
                                        error: false,
                                        message: 'Please select',
                                    };
                                    setError(errors);
                                }}
                                checked={formData.ontime === 'no' ? true : false}
                            />
                            <label className="form-check-label" htmlFor="flexRadioDefaulttime4">
                                No
                            </label>
                        </div>
                        {errors?.ontime?.required && errors?.ontime?.error && isSubmit && (
                            <div className="text-danger ft-12"> {errors?.ontime.message}</div>
                        )}
                    </div>
                </div>
            </>
        );
    };

    return (
        <>
            <div className="container dash-container">
                <div className="dash_bread_box">
                    <ul>
                        <li>Finalised Bids</li>
                    </ul>
                </div>
                <div className="content_body_cover">
                    <List
                        ref={listRef}
                        headTitles={[
                            'Demand Id',
                            'Bid Id',
                            'Transporter Name',
                            'Deliver To',
                            'Phone No.',
                            // 'Category Name',
                            // 'Item Name',
                            'Rating ',
                            // 'Remark',
                            'Status',
                        ]}
                        type={'finalised'}
                        tab={'vendor...'}
                        searchItem={searchItem}
                        list={FinalisedBids}
                        getById={getFinalisedBidsById}
                        updateStatus={updateStatus}
                        demandModel={handleShowDemandModal}
                        addUpdateText="Demand"
                        addModel="add_model"
                        editModel="edit_model"
                        callPagination={getFinalisedBids}
                        recordCount={recordCount}
                        helperText={'Search By Vendor Name ,Demand Id,Bid Id,Phone No.'}
                    />
                </div>
                {demandModel && (
                    <CommonModal
                        data={viewdata}
                        showModel={true}
                        demanModelCallback={() => {
                            setDemandModel(false);
                        }}
                    />
                )}

                {
                    <CommonRatingModal
                        show={showRatingModal}
                        onHide={handleHideRatingModal}
                        onRatingSubmit={handleRatingSubmit}
                    />
                }

                {viewModel && (
                    <Modal
                        scrollable={true}
                        show={true}
                        onHide={() => handelViewModel(false)}
                        backdrop="static"
                        keyboard={false}
                    >
                        <Modal.Header closeButton>
                            <Modal.Title>View</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="material_form_cover stepper_form_cover">
                                <form
                                    onSubmit={e => {
                                        e.preventDefault();
                                    }}
                                >
                                    {bidData == 'notArrived' ? (
                                        <>
                                            <div className="custom_row">
                                                <div className="col_left_box">
                                                    <div className="mid_dot_line"></div>
                                                </div>
                                                <div className="col_right_box">
                                                    <div className="field_box">
                                                        <h3 className="head_box_cover">
                                                            <span className="head_box">1</span>
                                                            <b>Not Arrived</b>
                                                        </h3>
                                                        <br></br>
                                                        <h3>
                                                            <b>Delivery Status</b>
                                                        </h3>
                                                        <div className="check_field_box mb-4">
                                                            <div className="form-check">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="flexRadioDefault"
                                                                    id="flexRadioDefault1"
                                                                    value={'arrived'}
                                                                    checked={viewdata?.deliveryStatus === 'arrived'}
                                                                    disabled={true}
                                                                />
                                                                <label
                                                                    className="form-check-label"
                                                                    htmlFor="flexRadioDefault1"
                                                                >
                                                                    Arrived
                                                                </label>
                                                            </div>
                                                            <div className="form-check">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="flexRadioDefault"
                                                                    id="flexRadioDefault2"
                                                                    value={'notArrived'}
                                                                    checked={viewdata?.deliveryStatus === 'notArrived'}
                                                                    disabled={true}
                                                                />
                                                                <label
                                                                    className="form-check-label"
                                                                    htmlFor="flexRadioDefault2"
                                                                >
                                                                    Not Arrived
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {viewdata.rating_appUser == null ? (
                                                <>
                                                    <div className="form-floating">
                                                        <h3>
                                                            <b>Transporter Rating</b>
                                                        </h3>
                                                        {actionsPermissionValidator(
                                                            location.pathname,
                                                            ActionValues.Edit,
                                                        ) ? (
                                                            <Button
                                                                className="btn rateNowblue_btn custom_btn"
                                                                onClick={() => {
                                                                    handleShowRatingModal();
                                                                    setedit(true);
                                                                    handelViewModel(false);
                                                                }}
                                                            >
                                                                Rate Transporter
                                                            </Button>
                                                        ) : (
                                                            ''
                                                        )}
                                                    </div>
                                                </>
                                            ) : viewdata?.rating_appUser !== null ? (
                                                <>
                                                    <>
                                                        <div className="col-sm-12">
                                                            <div className="form-floating">
                                                                <h3 style={{ marginBottom: '0px' }}>
                                                                    <b>Transporter Rating</b>
                                                                </h3>
                                                                <ReactStars
                                                                    count={5}
                                                                    value={viewdata?.rating_appUser?.rating}
                                                                    size={25}
                                                                    isHalf={true}
                                                                    edit={false}
                                                                    activeColor="#ffd700"
                                                                />
                                                            </div>

                                                            {viewdata?.rating_appUser?.remark && (
                                                                <div
                                                                    className="form-floating"
                                                                    style={{ marginTop: '15px' }}
                                                                >
                                                                    <div className="form-floating">
                                                                        <input
                                                                            id="remarks"
                                                                            className="form-control"
                                                                            placeholder="Remark"
                                                                            value={viewdata?.rating_appUser?.remark}
                                                                            disabled={true}
                                                                        />
                                                                        <label htmlFor="floatingInput">Remarks</label>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </>
                                                </>
                                            ) : (
                                                <></>
                                            )}
                                        </>
                                    ) : bidData == 'cancelled' ? (
                                        <>
                                            <div className="custom_row">
                                                <div className="col_left_box">
                                                    <div className="mid_dot_line"></div>
                                                </div>
                                                <div className="col_right_box">
                                                    <div className="field_box">
                                                        <h3 className="head_box_cover">
                                                            <span className="head_box">1</span>
                                                            <b>Transporter Denied</b>
                                                        </h3>
                                                        <br></br>
                                                        <h3>
                                                            <b>Delivery Status</b>
                                                        </h3>
                                                        <div className="check_field_box mb-4">
                                                            <div className="form-check">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="flexRadioDefault"
                                                                    id="flexRadioDefault1"
                                                                    value={'arrived'}
                                                                    checked={viewdata?.deliveryStatus === 'arrived'}
                                                                    disabled={true}
                                                                />
                                                                <label
                                                                    className="form-check-label"
                                                                    htmlFor="flexRadioDefault1"
                                                                >
                                                                    Arrived
                                                                </label>
                                                            </div>
                                                            <div className="form-check">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="flexRadioDefault"
                                                                    id="flexRadioDefault2"
                                                                    value={'notArrived'}
                                                                    checked={viewdata?.deliveryStatus === 'notArrived'}
                                                                    disabled={true}
                                                                />
                                                                <label
                                                                    className="form-check-label"
                                                                    htmlFor="flexRadioDefault2"
                                                                >
                                                                    Not Arrived
                                                                </label>
                                                            </div>
                                                            <div className="form-check">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="flexRadioDefault"
                                                                    id="flexRadioDefault2"
                                                                    value={'notArrived'}
                                                                    checked={viewdata?.deliveryStatus === 'cancelled'}
                                                                    disabled={true}
                                                                />
                                                                <label
                                                                    className="form-check-label"
                                                                    htmlFor="flexRadioDefault2"
                                                                >
                                                                    Cancelled
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <h3 className="head_box_cover">
                                                            {/* <span className="head_box">1</span> */}
                                                            <b>Reason for cancelled</b>
                                                        </h3>
                                                        <div className="form-floating">
                                                            <input
                                                                id="remarks"
                                                                className="form-control"
                                                                placeholder="Reason"
                                                                value={viewdata?.reason}
                                                                disabled={true}
                                                            />
                                                            <label htmlFor="floatingInput">Reason</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {viewdata.rating_appUser == null ? (
                                                <>
                                                    <div className="form-floating">
                                                        <h3>
                                                            <b>Transporter Rating</b>
                                                        </h3>
                                                        {actionsPermissionValidator(
                                                            location.pathname,
                                                            ActionValues.Edit,
                                                        ) ? (
                                                            <Button
                                                                className="btn rateNowblue_btn custom_btn"
                                                                onClick={() => {
                                                                    handleShowRatingModal();
                                                                    setedit(true);
                                                                    handelViewModel(false);
                                                                }}
                                                            >
                                                                Rate Transporter
                                                            </Button>
                                                        ) : (
                                                            ''
                                                        )}
                                                    </div>
                                                </>
                                            ) : viewdata?.rating_appUser !== null ? (
                                                <>
                                                    <>
                                                        <div className="col-sm-12">
                                                            <div className="form-floating">
                                                                <h3 style={{ marginBottom: '0px' }}>
                                                                    <b>Transporter Rating</b>
                                                                </h3>
                                                                <ReactStars
                                                                    count={5}
                                                                    value={viewdata?.rating_appUser?.rating}
                                                                    size={25}
                                                                    isHalf={true}
                                                                    edit={false}
                                                                    activeColor="#ffd700"
                                                                />
                                                            </div>
                                                            {viewdata?.rating_appUser?.remark && (
                                                                <div
                                                                    className="form-floating"
                                                                    style={{ marginTop: '15px' }}
                                                                >
                                                                    <div className="form-floating">
                                                                        <input
                                                                            id="remarks"
                                                                            className="form-control"
                                                                            placeholder="Remark"
                                                                            value={viewdata?.rating_appUser?.remark}
                                                                            disabled={true}
                                                                        />
                                                                        <label htmlFor="floatingInput">Remarks</label>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </>
                                                </>
                                            ) : (
                                                <></>
                                            )}
                                        </>
                                    ) : (
                                        <>
                                            {/* stepper start */}
                                            <div className="custom_row">
                                                <div className="col_left_box">
                                                    <div className="mid_dot_line"></div>
                                                </div>

                                                <div className="col_right_box">
                                                    <div className="field_box">
                                                        <h3 className="head_box_cover">
                                                            <span className="head_box">1</span>
                                                            <b>Arrived</b>
                                                        </h3>

                                                        <h3>
                                                            <b>Vehicle Arrival Status</b>
                                                        </h3>
                                                        <div className="check_field_box mb-4">
                                                            <div className="form-check">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="flexRadioDefaulttime9"
                                                                    id="flexRadioDefaulttime5"
                                                                    value={'yes'}
                                                                    checked={true}
                                                                    disabled={true}
                                                                />
                                                                <label
                                                                    className="form-check-label"
                                                                    htmlFor="flexRadioDefaulttime5"
                                                                >
                                                                    Arrived
                                                                </label>
                                                            </div>
                                                            <div className="form-check">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="flexRadioDefaulttime1"
                                                                    id="flexRadioDefaulttime6"
                                                                    value={'no'}
                                                                    disabled={true}
                                                                />
                                                                <label
                                                                    className="form-check-label"
                                                                    htmlFor="flexRadioDefaulttime6"
                                                                >
                                                                    Not Arrived
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-12">
                                                            <div className="form-floating d-flex">
                                                                {/* Commited Pickup Date & Time {formattedDate} */}
                                                                <div style={{ fontSize: 14 }}>
                                                                    Commited Arrival Date & Time
                                                                </div>
                                                                <div
                                                                    style={{
                                                                        fontSize: 14,
                                                                        marginLeft: 10,
                                                                        fontWeight: 500,
                                                                    }}
                                                                >
                                                                    {formatDate(viewdata?.demand?.pickUpDate)}
                                                                </div>
                                                            </div>
                                                            <br></br>
                                                            <div className="form-floating">
                                                                <CustomDateTimePicker
                                                                    data={{
                                                                        name: 'actualdeliverydate',
                                                                        placeholder: 'Select Arrival Date & Time',
                                                                        id: 'floatingInput',
                                                                        label: 'Vehical Arrival Date & Time',
                                                                        date: formattedDate,
                                                                    }}
                                                                    controlName="actualdeliverydate"
                                                                    isSubmit={isSubmit}
                                                                    value={viewdata?.actualDeliveryDate}
                                                                    disabled={true}
                                                                />
                                                            </div>
                                                        </div>
                                                        <br></br>
                                                        <h3>
                                                            <b>Was arrived on time?</b>
                                                        </h3>

                                                        <div className="check_field_box mb-4">
                                                            <div className="form-check">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="flexRadioDefaulttime2"
                                                                    id="flexRadioDefaulttime3"
                                                                    value={'yes'}
                                                                    checked={viewdata?.isArrived === true}
                                                                    disabled={true}
                                                                />
                                                                <label
                                                                    className="form-check-label"
                                                                    htmlFor="flexRadioDefaulttime3"
                                                                >
                                                                    Yes
                                                                </label>
                                                            </div>
                                                            <div className="form-check">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="flexRadioDefaulttime5"
                                                                    id="flexRadioDefaulttime4"
                                                                    value={'no'}
                                                                    checked={viewdata?.isArrived === false}
                                                                    disabled={true}
                                                                />
                                                                <label
                                                                    className="form-check-label"
                                                                    htmlFor="flexRadioDefaulttime4"
                                                                >
                                                                    No
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <h3 className="head_box_cover">
                                                        <span className="head_box">2</span>
                                                        <b>Dispatched</b>
                                                    </h3>
                                                    <br></br>
                                                    {bidData === 'arrived' ? (
                                                        <>
                                                            <h3>
                                                                Vehicle dispatched ? <b>If yes update the status</b>
                                                            </h3>
                                                            <div className="form-floating">
                                                                {actionsPermissionValidator(
                                                                    location.pathname,
                                                                    ActionValues.Edit,
                                                                ) ? (
                                                                    <Button
                                                                        className="btn bidsblue_btn custom_btn"
                                                                        onClick={() => {
                                                                            errors['dispatchedDeliveryDate'] = {
                                                                                required: true,
                                                                                error: true,
                                                                                message: 'Please select date',
                                                                            };
                                                                            // console.log('errors', errors)
                                                                            setError(errors);
                                                                            handelModel(true);
                                                                            setedit(true);
                                                                            handelViewModel(false);
                                                                        }}
                                                                    >
                                                                        update Status
                                                                    </Button>
                                                                ) : (
                                                                    ''
                                                                )}
                                                            </div>
                                                        </>
                                                    ) : (
                                                        <div className="form-floating">
                                                            <CustomDateTimePicker
                                                                data={{
                                                                    name: 'actualdeliverydate',
                                                                    placeholder: 'Vehicle Dispatch Date & Time',
                                                                    id: 'floatingInput',
                                                                    label: 'Vehicle Dispatch Date & Time',
                                                                    date: pickupdate,
                                                                }}
                                                                controlName="actualdeliverydate"
                                                                isSubmit={isSubmit}
                                                                value={viewdata?.dispatchedDeliveryDate}
                                                                setValue={(e: any) => getValue(e)}
                                                                errorMsg={errors?.actualdeliverydate.message}
                                                                inputProps={errors}
                                                                disabled={true}
                                                            />
                                                        </div>
                                                    )}

                                                    <br></br>

                                                    {bidData == 'dispatched' ? (
                                                        <div className="form-floating">
                                                            <h3>
                                                                <b>Delivered</b>
                                                            </h3>
                                                            <h3>
                                                                Vehicle delivered ? <b>If yes update the status</b>
                                                            </h3>
                                                            {actionsPermissionValidator(
                                                                location.pathname,
                                                                ActionValues.Edit,
                                                            ) ? (
                                                                <Button
                                                                    className="btn bidsblue_btn custom_btn"
                                                                    onClick={() => {
                                                                        handelModel(true);
                                                                        setedit(true);
                                                                        handelViewModel(false);
                                                                    }}
                                                                >
                                                                    update Status
                                                                </Button>
                                                            ) : (
                                                                ''
                                                            )}
                                                        </div>
                                                    ) : bidData == 'arrived' ? (
                                                        <></>
                                                    ) : (
                                                        <>
                                                            <h3 className="head_box_cover">
                                                                <span className="head_box">3</span>
                                                                <b>Delivered</b>
                                                            </h3>
                                                            <div className="col-sm-12">
                                                                <div className="form-floating d-flex">
                                                                    {/* Commited Delivery Date & Time
                                                                    {formattedDateDelivery} */}
                                                                    <div style={{ fontSize: 14 }}>
                                                                        Commited Delivery Date & Time
                                                                    </div>
                                                                    <div
                                                                        style={{
                                                                            fontSize: 14,
                                                                            marginLeft: 10,
                                                                            fontWeight: 500,
                                                                        }}
                                                                    >
                                                                        {formatDate(viewdata?.expectedDeliveryDate)}
                                                                    </div>
                                                                </div>
                                                                <br></br>
                                                                <div className="form-floating">
                                                                    <CustomDateTimePicker
                                                                        data={{
                                                                            name: 'deliveredDeliveryDate',
                                                                            placeholder: 'Select Delivery Date & Time',
                                                                            id: 'floatingInput',
                                                                            label: 'Vehical Delivery Date & Time',
                                                                            date: formattedDate,
                                                                        }}
                                                                        controlName="deliveredDeliveryDate"
                                                                        isSubmit={isSubmit}
                                                                        value={viewdata?.deliveredDeliveryDate}
                                                                        disabled={true}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <br></br>
                                                            <h3>
                                                                <b>Was vehicle delivered on time?</b>
                                                            </h3>
                                                            <div className="check_field_box mb-4">
                                                                <div className="form-check">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="radio"
                                                                        name="flexRadioDefaulttimew"
                                                                        id="flexRadioDefaulttime3"
                                                                        value={'yes'}
                                                                        checked={viewdata?.isOnTime === true}
                                                                        disabled={true}
                                                                    />
                                                                    <label
                                                                        className="form-check-label"
                                                                        htmlFor="flexRadioDefaulttime3"
                                                                    >
                                                                        Yes
                                                                    </label>
                                                                </div>
                                                                <div className="form-check">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="radio"
                                                                        name="flexRadioDefaulttime"
                                                                        id="flexRadioDefaulttime4"
                                                                        value={'No'}
                                                                        checked={viewdata?.isOnTime === false}
                                                                        disabled={true}
                                                                    />
                                                                    <label
                                                                        className="form-check-label"
                                                                        htmlFor="flexRadioDefaulttime4"
                                                                    >
                                                                        No
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </>
                                                    )}
                                                </div>
                                            </div>

                                            {/* end of stepper */}

                                            {bidData == 'delivered' && viewdata.rating_appUser == null ? (
                                                <>
                                                    <div className="form-floating">
                                                        <h3>
                                                            <b>Transporter Rating</b>
                                                        </h3>
                                                        {actionsPermissionValidator(
                                                            location.pathname,
                                                            ActionValues.Edit,
                                                        ) ? (
                                                            <Button
                                                                className="btn rateNowblue_btn custom_btn"
                                                                onClick={() => {
                                                                    handleShowRatingModal();
                                                                    setedit(true);
                                                                    handelViewModel(false);
                                                                }}
                                                            >
                                                                Rate Transporter
                                                            </Button>
                                                        ) : (
                                                            ''
                                                        )}
                                                    </div>
                                                </>
                                            ) : viewdata?.rating_appUser !== null ? (
                                                <>
                                                    <>
                                                        <div className="col-sm-12">
                                                            <div
                                                                className="form-floating"
                                                                style={{ marginBottom: '20px' }}
                                                            >
                                                                <h3 style={{ marginBottom: '0px' }}>
                                                                    <b>Transporter Rating</b>
                                                                </h3>
                                                                <ReactStars
                                                                    count={5}
                                                                    value={viewdata?.rating_appUser?.rating}
                                                                    size={25}
                                                                    isHalf={true}
                                                                    edit={false}
                                                                    activeColor="#ffd700"
                                                                />
                                                            </div>

                                                            {viewdata?.rating_appUser?.remark && (
                                                                <div className="form-floating">
                                                                    <div className="form-floating">
                                                                        <input
                                                                            id="remarks"
                                                                            className="form-control"
                                                                            placeholder="Remark"
                                                                            value={viewdata?.rating_appUser?.remark}
                                                                            disabled={true}
                                                                        />
                                                                        <label htmlFor="floatingInput">Remarks</label>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </>
                                                </>
                                            ) : (
                                                <></>
                                            )}
                                        </>
                                    )}
                                </form>
                            </div>
                        </Modal.Body>
                        <Modal.Footer></Modal.Footer>
                    </Modal>
                )}

                {showHideModel && (
                    <Modal show={true} onHide={() => handlereset()} backdrop="static" keyboard={false}>
                        <Modal.Header closeButton>
                            <Modal.Title> {'Update Status'}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {edit ? (
                                <div className="material_form_cover">
                                    <form
                                        onSubmit={e => {
                                            e.preventDefault();
                                        }}
                                    >
                                        {bidData == 'arrived'
                                            ? dispatchedModel()
                                            : bidData == 'dispatched'
                                                ? deliveryModel()
                                                : arrivedModel()}
                                    </form>
                                </div>
                            ) : (
                                ''
                            )}
                        </Modal.Body>
                        <Modal.Footer>
                            {bidData == 'arrived' || bidData == 'notArrived' ? (
                                <>
                                    <Button
                                        variant="secondary"
                                        className="btn dark_btn custom_btn"
                                        onClick={() => {
                                            updateBidStatus();
                                        }}
                                    >
                                        Update
                                    </Button>
                                    <Button
                                        variant="default"
                                        className="btn custom_btn border_btn with_icon"
                                        onClick={() => {
                                            handlereset();
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                </>
                            ) : (
                                <>
                                    <Button
                                        variant="secondary"
                                        className="btn dark_btn custom_btn"
                                        onClick={() => {
                                            updateBidStatus();
                                        }}
                                    >
                                        Update
                                    </Button>
                                    <Button
                                        variant="default"
                                        className="btn custom_btn border_btn with_icon"
                                        onClick={() => {
                                            handlereset();
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                </>
                            )}
                        </Modal.Footer>
                    </Modal>
                )}
            </div>
        </>
    );
}
